import { NUMBER_SIZE } from '../../../constants/size'
import { isImageFile } from '../../../utils/file'
import { FileIconPlaceholder } from '../FileIconPlaceholder'
import { FileIconThumbnail } from '../FileIconThumbnail'

import * as styles from './FileIconPreview.module.css'

function FileIconPreview({
  className = styles.icon,
  file,
  size = NUMBER_SIZE.size44,
  ...restProps
}) {
  const showThumbnail = file && isImageFile(file) && file.thumbnail

  const IconComponent = showThumbnail ? FileIconThumbnail : FileIconPlaceholder

  return (
    <IconComponent
      {...restProps}
      className={className}
      file={file}
      size={size}
    />
  )
}

export default FileIconPreview
